// src/config.js
export const WAITLIST_MODE = true; // flip to false when you want Stripe back
export const WAITLIST_URL =
  "https://docs.google.com/forms/d/e/1FAIpQLSdiLufbrMGcJBNx73tzZd8UMUIthJFb4koLzPk16efrw0-zRQ/viewform?usp=sharing";
export const DISCORD_URL = "https://discord.gg/ezp9Py2VKU";
export const CONTACT_EMAIL = "grandmasterai.com@gmail.com";
